import { createGlobalStyle, css } from 'styled-components';
import type { MarketCode } from '../../@types/Token';

// Font URLs from public folder
const OpenSauceOneBoldWoff = '/fonts/OpenSauceOne/OpenSauceOne-ExtraBold.woff';
const OpenSauceOneBoldWoff2 = '/fonts/OpenSauceOne/OpenSauceOne-ExtraBold.woff2';
const OpenSauceOneRegularWoff = '/fonts/OpenSauceOne/OpenSauceOne-Regular.woff';
const OpenSauceOneRegularWoff2 = '/fonts/OpenSauceOne/OpenSauceOne-Regular.woff2';

const StyreneABoldWoff = '/fonts/StyreneA/StyreneA-Bold-Web.woff';
const StyreneABoldWoff2 = '/fonts/StyreneA/StyreneA-Bold-Web.woff2';
const StyreneALightWoff = '/fonts/StyreneA/StyreneA-Light-Web.woff';
const StyreneALightWoff2 = '/fonts/StyreneA/StyreneA-Light-Web.woff2';
const StyreneAMediumWoff = '/fonts/StyreneA/StyreneA-Medium-Web.woff';
const StyreneAMediumWoff2 = '/fonts/StyreneA/StyreneA-Medium-Web.woff2';
const StyreneARegularWoff = '/fonts/StyreneA/StyreneA-Regular-Web.woff';
const StyreneARegularWoff2 = '/fonts/StyreneA/StyreneA-Regular-Web.woff2';

export default createGlobalStyle<{ market?: MarketCode }>`
  ${({ market }) =>
    market === 'SE'
      ? css`
          @font-face {
            font-family: 'Styrene A';
            src:
              url(${StyreneALightWoff2}) format('woff2'),
              url(${StyreneALightWoff}) format('woff');
            font-weight: 300;
            font-display: swap;
          }

          @font-face {
            font-family: 'Styrene A';
            src:
              url(${StyreneARegularWoff2}) format('woff2'),
              url(${StyreneARegularWoff}) format('woff');
            font-weight: 400;
            font-display: swap;
          }

          @font-face {
            font-family: 'Styrene A';
            src:
              url(${StyreneAMediumWoff2}) format('woff2'),
              url(${StyreneAMediumWoff}) format('woff');
            font-weight: 500;
            font-display: swap;
          }

          @font-face {
            font-family: 'Styrene A';
            src:
              url(${StyreneABoldWoff2}) format('woff2'),
              url(${StyreneABoldWoff}) format('woff');
            font-weight: 700;
            font-display: swap;
          }

          :root {
            --font-family: 'Styrene A', sans-serif;
            --font-weight-light: 300;
            --font-weight-regular: 400;
            --font-weight-medium: 500;
            --font-weight-bold: 700;
          }
        `
      : css`
          @font-face {
            font-family: 'Open Sauce One';
            src:
              url(${OpenSauceOneRegularWoff2}) format('woff2'),
              url(${OpenSauceOneRegularWoff}) format('woff');
            font-weight: 400;
            font-display: swap;
          }

          @font-face {
            font-family: 'Open Sauce One';
            src:
              url(${OpenSauceOneBoldWoff2}) format('woff2'),
              url(${OpenSauceOneBoldWoff}) format('woff');
            font-weight: 800;
            font-display: swap;
          }

          :root {
            --font-family: 'Open Sauce One', sans-serif;
            --font-weight-light: 400;
            --font-weight-regular: 400;
            --font-weight-medium: 800;
            --font-weight-bold: 800;
          }
        `}
`;
